import { IApiError } from '@/models/apiError.model';
import { IPaginationResponse } from '@/models/pagination.model';
import { IRedirect, IRedirectsImportResponse } from '@/models/redirect.model';

export const SLICE_NAME = 'redirects';

export interface RedirectsState {
  redirects: IRedirect[] | null;
  pagination: IPaginationResponse | null;
  isLoading: boolean;
  error: IApiError | null;
  importResult: IRedirectsImportResponse | null;
}

export const initialState: RedirectsState = {
  redirects: null,
  pagination: null,
  isLoading: false,
  error: null,
  importResult: null,
};
